<template>
    <div id="map">
        <!--<l-map :zoom="zoom" :center="center" ref="myMap" @update:zoom="zoomUpdated">
        </l-map>-->
    </div>
</template>

<script>
    import L from "leaflet";
    import unitService from "../service/UnitService";
    import vasService from "../service/VasService";
    import geoService from "../service/Geo"

    var sourceWindow = undefined;

    const tileProviders = [
        {
            name: "<span style='width:100%;text-align:left;'>Streetmaps</span>",
            visible: true,
            attribution:
                '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", premium: false
        },
        {
            name: "<span>Satelite</span>",
            visible: false,
            url:
                "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
            attribution:
                '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors', premium: false
        },
        {
            name: "<span>Streetmaps(Premium)</span>",
            visible: false,
            url:
                "https://1.traffic.maps.api.here.com/maptile/2.1/traffictile/newest/normal.day/{z}/{x}/{y}/256/png8?app_id=VHYUekNi4ovJkG1NHQjz&app_code=LiVvLGvrSgkJG2BmTjGYLA",
            attribution:
                '&copy; <a href="http://developer.here.com">HERE</a> contributors', premium: true
        },
        {
            name: "<span>Satelite (Premium)</span>",
            visible: false,
            url:
                "https://1.aerial.maps.api.here.com/maptile/2.1/maptile/newest/hybrid.day/{z}/{x}/{y}/256/png8?app_id=VHYUekNi4ovJkG1NHQjz&app_code=LiVvLGvrSgkJG2BmTjGYLA",

//            "https://1.aerial.maps.api.here.com/maptile/2.1/maptile/newest/hybrid.day/{z}/{x}/{y}/256/png8?app_id=RLzS0mYvlRouKSqt6zvo&app_code=dUErNUgUfhnrpF3K2xKfIg",
            attribution:
                '&copy; <a href="http://developer.here.com">HERE</a> contributors', premium: true
        }
    ];

    export default {
        name: "RealTimeMap",
        data() {
            return {
                rclFoods: undefined,
                uid: "",
                map: undefined,
                poi: undefined,
                history: {group: undefined, line: undefined, direction: undefined},
                pin: false,
                geocoder: undefined,
                markers: [],
                geofences: [],
                tileProviders: tileProviders,
                zoom: 6,
                center: L.latLng(-29.745, 23.379),
                greenMarker: undefined,
                orangeMarker: undefined,
                redMarker: undefined,
                purpleMarker: undefined,
                yellowMarker: undefined,
                arrows: {},
                premiumMaps: false,
                controls: undefined,
                isShowInfo : false
            };
        },

        mounted() {
            this.uid = this.$route.query.uid;

            var that = this;

            console.log("Finding map vas");

            vasService.getSubscription("MAP", this.uid).then(result => {
                if (result.length > 0) that.premiumMaps = true;
            }).catch(err => {
                console.log("Failed to get MAP vas", err);
            }).finally(() => {
                that.start();
                that.rcl();
            });


        },
        methods: {
            start() {
                this.map = L.map("map", {
                    center: this.center,
                    zoom: this.zoom,
                    contextmenu: true,
                    contextmenuWidth: 140,
                    contextmenuItems: [
                        {
                            text: "Add To MyPlaces",
                            callback: this.addToMyPlaces
                        },
                        {
                            text: "Center map here",
                            callback: this.centerMap
                        },
                        {
                            text: "View Street View",
                            callback: this.streetView,
                        },
                        "-",
                        {
                            text: "Zoom in",
                            //icon: 'images/zoom-in.png',
                            callback: this.zoomIn
                        },
                        {
                            text: "Zoom out",
                            //icon: 'images/zoom-out.png',
                            callback: this.zoomOut
                        }
                    ]
                });

                this.map.on("zoomend", this.zoomUpdated);

                this.$nextTick(() => {
                    this.geofences = new L.featureGroup();
                    this.map.addLayer(this.geofences);

                    var that = this;
                    var map = this.map;

                    this.createMarkers();

                    that.map.on(L.Draw.Event.CREATED, function (e) {
                        var type = e.layerType,
                            layer = e.layer;

                        var msg = {};
                        msg.event = "AddGeoFence";
                        msg.points = e.layer.editing.latlngs;

                        var bounds = e.layer.getBounds();
                        msg.topleft = bounds.getNorthWest();
                        msg.bottomright = bounds.getSouthEast();

                        console.log(JSON.stringify(msg));
                        sourceWindow.postMessage(JSON.stringify(msg), "*");
                    });

                    L.control.scale().addTo(this.map);

                    var baseLayers = {};
                    var overlays = {};

                    var index = 0;

                    for (var i = 0; i < tileProviders.length; i++) {
                        var tileLayer = L.tileLayer(tileProviders[i].url, {
                            attribution: tileProviders[i].attribution,
                            id: tileProviders[i].name
                        });

                        if (this.premiumMaps == true && tileProviders[i].premium == true) {
                            baseLayers[tileProviders[i].name] = tileLayer;

                            if (index == 0) tileLayer.addTo(map);
                            index++;
                        }

                        if (tileProviders[i].premium == false) {
                            baseLayers[tileProviders[i].name] = tileLayer;
                            if (index == 0) tileLayer.addTo(map);
                            index++;

                        }

                    }


                    this.controls = L.control.layers(baseLayers).addTo(map);

                    this.geocoder = L.Control.Geocoder.nominatim();
                    //this.geocoder.options.serviceUrl = "http://nominatim.selftrack.co.za/"

                    // Use HERE MAPS
                    //this.geocoder =  L.Control.Geocoder.here()
                    //this.geocoder.options.app_id="gypl9nklrXJO80b2zOw8";
                    //this.geocoder.options.app_code="Ib8M2pHf0JtftteMkW152A";

                    console.log(this.geocoder);

                    this.bindEvent(window, "message", function (e) {
                        if (e.data && typeof e.data == "string") {
                            var d = JSON.parse(e.data);

                            if (d.event !== undefined) {
                                if (sourceWindow === undefined) sourceWindow = e.source;

                                if (d.event == "AddUnit") {
                                    that.addUnit(d);
                                } else if (d.event == "RemoveUnit") {
                                    that.removeUnit(d.unitId);
                                } else if (d.event == "ZoomRealtime") {
                                    console.log("SZoom Relatimne called");
                                    that.fitBounds();
                                } else if (d.event == "Pin") {
                                    that.pinRealTime(d.value);
                                } else if (d.event == "MyPlaces") {
                                    that.myPlaces(d);
                                } else if (d.event === "ShowTrack") {
                                    that.showTrack(d.points);
                                    //console.log(d)
                                } else if (d.event === "RemoveTrack") {
                                    that.removeTrack();
                                    //console.log(d)
                                } else if (d.event === "ZoomHistory") {
                                    if (that.history != undefined) {
                                        that.map.fitBounds(that.history.group.getBounds());
                                    }
                                } else if (d.event == "BeginNewFence") {
                                    var polygonDrawer = new L.Draw.Polygon(that.map, {
                                        showArea: true,
                                        showLength: true
                                    });
                                    polygonDrawer.enable();
                                } else if (d.event === "ShowFence") {
                                    console.log("ShowFence ", JSON.stringify(d.fence));

                                    var col = "red";

                                    if (d.fence.inside === true) col = "green";

                                    var polygon = new L.Polygon(d.fence.points, {color: col});
                                    //polygon.color = color
                                    that.geofences.addLayer(polygon);
                                    that.map.fitBounds(that.geofences.getBounds());
                                } else if (d.event === "ClearFences") {
                                    console.log("ClearFencces", e);
                                    that.geofences.clearLayers();
                                } else if (d.event === "ShowInfo") {
                                    that.showInfo(d)
                                }
                            }
                        } // if valid data
                    });
                });
            },
            showCoordinates(event) {
            },
            centerMap(e) {
                this.map.panTo(e.latlng);
            },
            zoomIn(e) {
                this.map.zoomIn();
            },
            zoomOut(e) {
                this.map.zoomOut();
            },

            zoomUpdated(event) {
                var zoom = this.map.getZoom();

                var map = this.map;

                if (
                    this.history.direction != undefined &&
                    zoom > 13 &&
                    !map.hasLayer(this.history.direction)
                )
                    map.addLayer(this.history.direction);
                else if (
                    zoom <= 13 &&
                    this.history.direction != undefined &&
                    map.hasLayer(this.history.direction)
                )
                    map.removeLayer(this.history.direction);
            },

            createMarkers() {
                this.greenMarker = L.icon({
                    iconUrl: "markers/marker-icon-green.png",
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34]
                });

                this.orangeMarker = L.icon({
                    iconUrl: "markers/marker-icon-orange.png",
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34]
                });

                this.redMarker = L.icon({
                    iconUrl: "markers/marker-icon-red.png",
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34]
                });

                this.purpleMarker = L.icon({
                    iconUrl: "markers/marker-icon-violet.png",
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34]
                });

                this.yellowMarker = L.icon({
                    iconUrl: "markers/marker-icon-yellow.png",
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34]
                });

                this.arrows.N = L.icon({
                    iconUrl: "arrows/n.png",
                    iconSize: [16, 16],
                    iconAnchor: [8, 8]
                });
                this.arrows.NE = L.icon({
                    iconUrl: "arrows/ne.png",
                    iconSize: [16, 16],
                    iconAnchor: [8, 8]
                });
                this.arrows.NW = L.icon({
                    iconUrl: "arrows/nw.png",
                    iconSize: [16, 16],
                    iconAnchor: [8, 8]
                });

                this.arrows.S = L.icon({
                    iconUrl: "arrows/s.png",
                    iconSize: [16, 16],
                    iconAnchor: [8, 8]
                });
                this.arrows.SE = L.icon({
                    iconUrl: "arrows/se.png",
                    iconSize: [16, 16],
                    iconAnchor: [8, 8]
                });
                this.arrows.SW = L.icon({
                    iconUrl: "arrows/sw.png",
                    iconSize: [16, 16],
                    iconAnchor: [8, 8]
                });

                this.arrows.E = L.icon({
                    iconUrl: "arrows/e.png",
                    iconSize: [16, 16],
                    iconAnchor: [8, 8]
                });
                this.arrows.W = L.icon({
                    iconUrl: "arrows/w.png",
                    iconSize: [16, 16],
                    iconAnchor: [8, 8]
                });
            },

            removeTrack() {
                var map = this.map;

                if (this.history.group === undefined) return;

                if (this.history.line != undefined)
                    this.history.line.removeFrom(this.history.group);

                this.history.group.clearLayers();
                map.removeLayer(this.history.group);

                if (this.history.direction != undefined) {
                    this.history.direction.clearLayers();
                    map.removeLayer(this.history.direction);
                }

                this.history.line = undefined;
            },

            showTrack(points) {

                console.log("Points is ",points)
                var map = this.map;

                this.removeTrack();

                if (this.history.group === undefined) {
                    this.history.group = new L.FeatureGroup();
                }

                this.history.group.addTo(map);

                if (this.history.direction === undefined) {
                    this.history.direction = new L.FeatureGroup();
                }

                if (map.zoom > 13) this.history.direction.addTo(map);

                var line = [];

                for (var i = 0; i < points.length; i++) {
                    // Create Green marker
                    if (i === 0) {
                        var marker = L.marker([points[i].lat, points[i].lon], {
                            icon: this.greenMarker
                        });
                        var html = "<b> Driver</b>  : " + points[i].driver + "<br>";
                        html +=
                            "<b> Status</b> : " +
                            (points[i].speed > 0 ? "Moving" : "Stopped") +
                            "<br>";
                        html += "<b>Speed</b> : " + points[i].speed + "<br>";
                        html += "<b>Direction</b> : " + points[i].direction + "<br>";
                        html += "<b>Date</b> : " + points[i].date + "<br>";
                        html += "<b>Lat</b> : "+ points[i].lat + "<br>";
                        html += "<b>Lon</b> : "+ points[i].lon + "<br>";
                        marker.bindPopup(html);
                        this.history.group.addLayer(marker);
                        line.push([points[i].lat, points[i].lon]);
                    } else if (i === points.length - 1) {
                        var marker = L.marker([points[i].lat, points[i].lon], {
                            icon: this.redMarker
                        });
                        var html = "<b> Driver</b>  : " + points[i].driver + "<br>";
                        html +=
                            "<b> Status</b> : " +
                            (points[i].speed > 0 ? "Moving" : "Stopped") +
                            "<br>";
                        html += "<b>Speed</b> : " + points[i].speed + "<br>";
                        html += "<b>Direction</b> : " + points[i].direction + "<br>";
                        html += "<b>Date</b> : " + points[i].date + "<br>";
                        html += "<b>Lat</b> : "+ points[i].lat + "<br>";
                        html += "<b>Lon</b> : "+ points[i].lon + "<br>";
                        marker.bindPopup(html);
                        this.history.group.addLayer(marker);
                        line.push([points[i].lat, points[i].lon]);
                    } else {
                        var icon = this.arrows[points[i].direction];

                        if (icon == undefined) {
                            console.log("No ICON definded for ", points[i].direction);
                            icon = this.arrows["N"];
                        }
                        var marker = L.marker([points[i].lat, points[i].lon], {icon: icon});
                        var html = "<b> Driver</b>  : " + points[i].driver + "<br>";
                        html +=
                            "<b> Status</b> : " +
                            (points[i].speed > 0 ? "Moving" : "Stopped") +
                            "<br>";
                        html += "<b>Speed</b> : " + points[i].speed + "<br>";
                        html += "<b>Direction</b> : " + points[i].direction + "<br>";
                        html += "<b>Date</b> : " + points[i].date + "<br>";
                        html += "<b>Lat</b> : "+ points[i].lat + "<br>";
                        html += "<b>Lon</b> : "+ points[i].lon + "<br>";
                        marker.bindPopup(html);
                        this.history.direction.addLayer(marker);

                        line.push([points[i].lat, points[i].lon]);
                    }
                }

                this.history.line = L.polyline(line, {color: "red"});
                this.history.group.addLayer(this.history.line);

                console.log("adding directions", map.getZoom());
                if (map.getZoom() > 13) map.addLayer(this.history.direction);
            },

            myPlaces(data) {

                console.log("My Places",data)
                var map = this.map;

                if (this.poi === undefined && data.points !== undefined &&  data.points.length > 0) {
                    this.poi = new L.LayerGroup().addTo(map);
                }

                this.poi.clearLayers();

                if (data.value === true) {
                    for (var i = 0; i < data.points.length; i++) {
                        var marker = undefined;
                        var color = data.points[i].color;

                        if (color === "blue")
                            marker = L.marker([data.points[i].lat, data.points[i].lon]);
                        else if (color === "green")
                            marker = L.marker([data.points[i].lat, data.points[i].lon], {
                                icon: this.greenMarker
                            });
                        else if (color === "orange")
                            marker = L.marker([data.points[i].lat, data.points[i].lon], {
                                icon: this.orangeMarker
                            });
                        else if (color === "red")
                            marker = L.marker([data.points[i].lat, data.points[i].lon], {
                                icon: this.redMarker
                            });
                        else if (color === "purple")
                            marker = L.marker([data.points[i].lat, data.points[i].lon], {
                                icon: this.purpleMarker
                            });
                        else if (color === "yellow")
                            marker = L.marker([data.points[i].lat, data.points[i].lon], {
                                icon: this.yellowMarker
                            });
                        else marker = L.marker([data.points[i].lat, data.points[i].lon]);

                        marker.bindPopup(
                            "<b>" + data.points[i].name + "</b><br>" + data.points[i].address
                        );
                        this.poi.addLayer(marker);

                        var circle = L.circle([data.points[i].lat, data.points[i].lon], {
                            radius: data.points[i].radius,
                            color: data.points[i].color
                        });
                        this.poi.addLayer(circle);
                    }
                }
            },
            showInfo(data) {

                console.log(data)
                this.isShowInfo = data.value;

                for (var i = 0; i <  this.markers.length; i++) {

                    var marker = this.markers[i]
                   // var tooltip = marker.getTooltip();

                    marker.closeTooltip()
                    marker.unbindTooltip();

                    if (this.isShowInfo) {
                        marker.bindTooltip(marker.properties.unit.name + "<br>"
                            + marker.properties.speed + " km\h", {"permanent": true, offset: [0, -37], direction: 'top'}).openTooltip();
                    } else {
                        marker.bindTooltip(marker.properties.unit.name + "<br>"
                            + marker.properties.speed + " km\h", {"permanent": false, offset: [0, -37], direction: 'top'});//.openTooltip();

                        marker.closeTooltip()
                    }

                }

            },

            // Add ot update the unit on the map
            addUnit(d) {

                console.log(d)
                var that = this;
                var map = this.map;
                var marker = this.getMarker(d.unit.id);
                if (marker === undefined) {
                    let heading = 270+parseInt(d.heading)
                    var myIcon = L.icon({
                        iconUrl: "sprites/" + d.iconColor + "/" + d.iconName + ".png",
                        //iconUrl: "http://self2.selftrack.co.za/icon?image="+d.iconName+"&color="+d.iconColor+"&rotate=0",
                        iconSize: [40, 40],
                        iconAnchor: [16, 37],
                        popupAnchor: [0, -30]
                    });
                    var marker = L.marker([d.lat, d.lon], {
                        icon: myIcon,
                        riseOnHover: true,
                        contextmenu: true,
                        contextmenuItems: [
                            {
                                separator: true,
                                index: 1
                            },
                            {
                                text: "Directions from here",
                                callback: this.directions,
                                index: 2
                            },

                            {
                                text: "Immobilize",
                                callback: this.immobilize,
                                disabled: true,
                                index: 3
                            },
                            {
                                text: "Cancel Immobilize",
                                callback: this.cancelImmobilize,
                                disabled: true,
                                index: 4
                            },
                            {
                                separator: true,
                                index: 5
                            },
                        ]
                    });
                    marker.id = d.unit.id;
                    marker.properties = {};
                    marker.properties.speed = d.speed;
                    marker.properties.status = d.status;
                    marker.properties.timestamp = d.timestamp;
                    marker.properties.unit = d.unit;

                    console.log("Driver is ", d.driver)

                    if (d.driver != "" ) marker.properties.unit.regular_driver = d.driver;

                    marker.polyline = L.polyline([[d.lat, d.lon]], {color: "blue"}).addTo(
                        map
                    );
                    marker.properties.color = d.iconColor;

                    if (that.isShowInfo) {
                        marker.bindTooltip(d.unit.name + "<br>"
                            + d.speed + " km\h", {"permanent": that.isShowInfo, offset: [0, -37], direction: 'top'}).openTooltip();
                    } else {
                        marker.bindTooltip(d.unit.name + "<br>"
                            + d.speed + " km\h", {"permanent": false, offset: [0, -37], direction: 'top'}).openTooltip();
                    }

                    marker
                        .bindPopup("Loading Address ...")
                        .addTo(map)
                        .on("click", function (e) {
                            e.sourceTarget.setPopupContent("Loading ...");
                            geoService.reverse(e.latlng.lat, e.latlng.lng).then(result => {
                                console.log(result);
                                var html =
                                    "<b> Name : </b>" + e.sourceTarget.properties.unit.name;
                                html +=
                                    "<br><b> Driver : </b>" +
                                    e.sourceTarget.properties.unit.regular_driver;
                                html +=
                                    "<br><b> Status : </b>" +
                                    e.sourceTarget.properties.status;
                                html +=
                                    "<br><b> TimeStamp : </b>" +
                                    e.sourceTarget.properties.timestamp;
                                html +=
                                    "<br><b> Description/Reg No : </b>" +
                                    e.sourceTarget.properties.unit.description;
                                html +=
                                    "<br><b>Speed :</b> " +
                                    e.sourceTarget.properties.speed +
                                    " km/h <br>";
                                html += "<br><b>Address : </b>"// + results[0].name;

                                html += result //that.formatAddress(result)

                                e.sourceTarget.setPopupContent(html);
                            }).catch((err)=> {
                                console.log(err)
                            })
                        });


                    vasService.getSubscriptionByImei("IMMOBILIZE", d.unit.imei).then(result => {

                        if (result.length > 0) {
                            console.log("Immobilize is ", JSON.stringify(result[0].settings),d.unit.imei)

                            if (result[0].settings && result[0].settings.activated == true) {
                                marker.options.contextmenuItems[2].disabled = true
                                marker.options.contextmenuItems[3].disabled = false
                            }else {
                                marker.options.contextmenuItems[2].disabled = false
                                marker.options.contextmenuItems[3].disabled = true
                            }
                        } else {
                            marker.options.contextmenuItems[2].disabled=true
                            marker.options.contextmenuItems[3].disabled=true
                        }
                    }).catch(err => {
                        this.errorToast("Failed to get MAP vas" + err);
                    }).finally(() => {

                        console.log(marker.options.contextmenuItems)
                        that.markers.push(marker);
                        that.fitBounds();
                    });

                    ///////////

                } else {

                     console.log("ICON IS" , marker.options);
                    if (
                        marker.getLatLng().lat != d.lat &&
                        marker.getLatLng().lon != d.lon
                    ) {
                        let heading = 270+parseInt(d.heading)

                        console.log("HEADING IS " + heading)

                        marker.properties.speed = d.speed;
                        marker.polyline.addLatLng([d.lat, d.lon]);
                        marker.setLatLng([d.lat, d.lon]);
                        marker.closePopup();
                        marker.options.icon.iconUrl="http://self2.selftrack.co.za/icon?image="+d.iconName+"&color="+d.iconColor+"&rotate=0",

                        //console.log("ICON IS" , marker.options.icon.iconUrl);

                        marker.setPopupContent("Loading ....");


                        // Fit to bound to follow realtime
                        if (this.Pin === true) this.fitBounds();
                    } else {
                        console.log("Doing nothing lat/ln same for unit");
                    }

                    var tooltip =  marker.getTooltip()
                    tooltip.setContent(d.unit.name + "<br>"+ d.speed + " km\h")

                }
            },
            addToMyPlaces(e) {
                var msg = {};
                msg.event = "AddMyPlace";
                msg.latlng = e.latlng;

                //this.geocoder.reverse(e.latlng,100000000, function(results) {
                //    console.log(results[0])
                //msg.address = results[0].name
                console.log(JSON.stringify(msg));
                sourceWindow.postMessage(JSON.stringify(msg), "*");

                //});

                //window.parent.postMessage(JSON.stringify(msg), 'http://127.0.0.1:8888');
            },
            removeUnit(unitId) {
                for (var i = this.markers.length; i--;) {
                    if (this.markers[i].id === unitId) {
                        this.markers[i].polyline.remove();
                        this.markers[i].removeFrom(this.map);
                        this.markers.splice(i, 1);
                    }
                }
               this.fitBounds();
            },
            pinRealTime(value) {
                this.Pin = value;

                if (this.Pin == true) {
                    this.fitBounds();
                }
            },
            getMarker(unitId) {
                for (var i = 0; i < this.markers.length; i++) {
                    if (this.markers[i].id === unitId) return this.markers[i];
                }

                return undefined;
            },
            fitBounds() {
                if (this.markers.length > 1) {
                    var group = new L.featureGroup(this.markers);
                    this.map.fitBounds(group.getBounds());
                } else if (this.markers.length == 1) {
                    this.map.setView(this.markers[0].getLatLng(), 15);
                } else {
                    this.zoom = 6;
                    this.map.setView(L.latLng(-29.745, 23.379), 6);
                }
            },
            bindEvent(element, eventName, eventHandler) {
                if (element.addEventListener) {
                    element.addEventListener(eventName, eventHandler, false);
                } else if (element.attachEvent) {
                    element.attachEvent("on" + eventName, eventHandler);
                }
            },
            streetView(e) {
                console.log(e);
                var lat = e.latlng.lat;
                var lon = e.latlng.lng;

                //https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=-25.775224,28.2516533,8z
                window.open(
                    "https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=" +
                    lat +
                    "," +
                    lon,
                    "streetview"
                );
            },
            directions(e) {
                console.log(e);
                var lat = e.latlng.lat;
                var lon = e.latlng.lng;

                window.open(
                    "https://www.google.com/maps/dir/?api=1&origin=" + lat + "," + lon,
                    "directions"
                );
            },
            immobilize(e) {
                var that = this;

                that.map.openPopup("Immobilising the unit .... Please Wait", [
                    e.latlng.lat,
                    e.latlng.lng
                ]);

                var imei = e.relatedTarget.properties.unit.imei;
                unitService.immobilize(imei, that.uid).then(result => {

                    console.log("IMM",result)
                    that.map.openPopup(
                        "<br><b style='color:red'>Message was send to <br>device to immobilise</b><br><br>",
                        [e.latlng.lat, e.latlng.lng]
                    );

                    e.relatedTarget.options.contextmenuItems[2].disabled = true
                    e.relatedTarget.options.contextmenuItems[3].disabled = false
                }).catch(error => {
                    that.map.openPopup(
                        "<br><b style='color:red'>" + error + "</b><br><br>",
                        [e.latlng.lat, e.latlng.lng]
                    );
                });
            },
            cancelImmobilize(e) {
                var that = this;
                var imei = e.relatedTarget.properties.unit.imei;

                that.map.openPopup("Cancelling the immobilisation .... Please Wait", [
                    e.latlng.lat,
                    e.latlng.lng
                ]);


                unitService.cancelImmobilize(imei, that.uid).then(result => {

                    that.map.openPopup(
                        "<br><b style='color:green'>Message was send to <br>device to cancel immobilise</b><br><br>",
                        [e.latlng.lat, e.latlng.lng]
                    );

                    e.relatedTarget.options.contextmenuItems[2].disabled = false
                    e.relatedTarget.options.contextmenuItems[3].disabled = true

                }).catch(error => {
                    that.map.openPopup(
                        "<br><b style='color:red'>" + error + "</b><br><br>",
                        [e.latlng.lat, e.latlng.lng]
                    );
                });

            },
            rcl() {

                vasService.getSubscription("RCLFOODS", this.uid).then(result => {
                    if (result.length > 0) {


                        console.log("Add RCL to maps");

                        this.rclFoods = L.geoJSON()
                            .bindPopup(function (layer) {
                                console.log(layer.feature.properties)
                                /*var html = "<b>Id Code:</b>" + layer.feature.properties.ID_CODE +
                                    "<br><b>First Field:</b>" + layer.feature.properties.FIRST_FIEL +
                                    "<br><b>First Field:</b>" + layer.feature.properties.FIRST_FIEL +
                                    "<br><b>First Grow::</b>" + layer.feature.properties.FIRST_GROW +
                                    "<br><b>First Map:</b>" + layer.feature.properties.FIRST_MAP_ +
                                    "<br><b>First Mill:</b>" + layer.feature.properties.FIRST_Mill*/

                                var html = "<b>GROWER_COD:</b>" + layer.feature.properties.GROWER_COD +
                                    "<br><b>GROWER_NAM:</b>" + layer.feature.properties.GROWER_NAM  
                                return html;
                            });



                        //overlays["RCL Foods"]=this.rclFoods

                        vasService.loadGeoJSON().then(response => {
                            console.log(response)

                            this.rclFoods.addData(response);

                            //this.rclFoods.addTo(this.map);

                            this.controls.addOverlay(this.rclFoods,"RCL Foods")

                            this.toast("RCL Food layers was added ")

                        });


                    } else {

                        if (this.rclFoods != undefined) {
                            this.rclFoods.clearLayers();
                        }

                    }
                }).catch(err => {
                    console.log("Failed to get RCLFoods vas", err);
                    this.errorToast("Failed to load the RCL layers ")
                });
            },
            toast(message) {

                let toast = this.$toasted.success(message,{
                    duration : 3000
                });
            },
            errorToast(message) {

                let toast = this.$toasted.error(message,{
                    duration : 3000
                });
            },
            formatAddress(results) {
                var html = "";//"<table cellspacing='1' cellpadding='1' style='padding:1px;'>";


                /*if (typeof  results.properties.address.house_number !== 'undefined')
                    html += results.properties.address.house_number + ", "
                if (typeof  results.properties.address.road !== 'undefined')
                    html += results.properties.address.road + ", "
                if (typeof  results.properties.address.street !== 'undefined')
                    html += results.properties.address.street + ", "
                if (typeof  results.properties.address.suburb !== 'undefined')
                    html += results.properties.address.suburb+ ", "
                if (typeof  results.properties.address.city !== 'undefined')
                    html += results.properties.address.city+ ", "
                if (typeof  results.properties.address.state !== 'undefined')
                    html += results.properties.address.state+ ", "*/

                html += results.freeformAddress

                return html;

            }
        }
    };
</script>

<style scoped>
    #map {
        height: calc(100% - 15px);
        width: 100%;
        position: absolute !important;
    }
</style>
